/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["sd-Deva",[["AM","PM"],u,["सुबुह जा","शाम जा"]],[["AM","PM"]],[["आ","सू","मं","बु॒","वि","जु","छं"],["आर्त","सू","मंग","बु॒ध","विस","जुम","छंछ"],["आर्तवार","सूमर","मंगलु","ॿुधर","विस्पत","जुमो","छंछर"],["आर्त","सू","मंग","बु॒ध","विस","जुम","छंछ"]],[["आ","सू","मं","बु॒","वि","जु","छं"],["आ","सू","मं","बुध","विस","जु","छंछ"],["आर्त","सू","मं","बु॒ध","विस","जुम","छंछ"],["आर्त","सू","मंग","बु॒ध","विस","जुम","छंछ"]],[["ज","फ़","मा","अ","मा","जू","जु","अग","स","ऑ","न","डि"],["जन","फर","मार्च","अप्रै","मई","जून","जु","अग","सप्टे","ऑक्टो","नवं","डिसं"],["जनवरी","फेबरवरी","मार्चु","अप्रेल","मई","जून","जुलाई","आगस्ट","सप्टेंबर","आक्टोबर","नवंबर","डिसंबर"]],[["ज","फ़","म","अ","मा","जू","जु","अग","स","ऑ","न","डि"],["जन","फर","मार्च","अप्रै","मई","जून","जुला","अग","सप्टे","ऑक्टो","नवं","डिसं"],["जनवरी","फेबरवरी","मार्चु","अप्रेल","मई","जून","जुलाई","आगस्ट","सप्टेंबर","ऑक्टोबर","नवंबर","डिसंबर"]],[["बीसी","एडी"]],0,[0,0],["M/d/yy","MMM d, y","MMMM d, y","EEEE, MMMM d, y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"INR","₹","हिंदुस्तानी रुपयो",{},"ltr", plural];
